import { Injectable } from '@angular/core';
import moment from 'moment';
import { BehaviorSubject, Observable, fromEvent } from 'rxjs';

/**
 * The Last active service detects user (in)activity. Activity is stored every 10 seconds by default. 
 */
@Injectable({
  providedIn: 'root'
})
export class LastActiveService {

  private localStorageKey: string = '__lastActive';
  private events: string[] = ['keydown', 'click', 'wheel', 'mousemove'];

  private lastActive: BehaviorSubject<Date>;
  public lastActive$: Observable<Date>;

  private recordTimeoutMs: number = 10000; //10 seconds

  constructor() {
    const lastActiveDate = this.getLastActiveFromLocalStorage() ?? new Date();
    this.lastActive = new BehaviorSubject<Date>(lastActiveDate);
    this.lastActive$ = this.lastActive.asObservable();
  }
  
  public run() {
    this.events.forEach(event =>
      fromEvent(document, event).subscribe(_ => this.recordLastActiveDate())
    );  

    //synchronise the login state between different tabs
    // fromEvent<StorageEvent>(window, 'storage')
    //   .pipe(
    //     filter(event => event.storageArea === localStorage && event.key === this.localStorageKey && !!event.newValue),
    //     map(event => new Date(event.newValue as string))
    //   )
    //   .subscribe(newDate => this.lastActive.next(newDate));
  }

  public getLastActiveDate(): Date {
    return this.lastActive.value;
  }
  
  private recordLastActiveDate() {
    var currentDate = moment(new Date());

    if (moment.duration(currentDate.diff(this.getLastActiveDate())).asMilliseconds() < this.recordTimeoutMs) {
      return;
    }

    localStorage.setItem(this.localStorageKey, currentDate.toString());
    this.lastActive.next(currentDate.toDate());
  }

  private getLastActiveFromLocalStorage(): Date | null {
    const valueFromStorage = localStorage.getItem(this.localStorageKey);
    
    if (!valueFromStorage) {
      return null;
    }

    return new Date(valueFromStorage);
  }
}